export default "__VITE_ASSET__dfc13444__"